<!--
  Lista "Prepara Ordine" — pattern Diakonix native (v2.11.0 J.1 polish #2).
  Layout allineato a assegna-ordine v2.10.0 I.1:
   - Sticky header con titolo + subtitle conteggio
   - KPI banner 3+4 (Totale/Completi/Parziali sopra · Assegnati/In Lavorazione/Sospesi/Bloccati sotto)
   - Filter bar con searchbar + date range allineati
   - Table HTML semantico (no div-grid) con icon-btn emoji
   - Row tinting per status (no parziale visivo per richiesta PM)
-->
<div class="prep-page">

  <!-- ============ STICKY HEADER ============ -->
  <header class="prep-header">
    <div class="title-block">
      <h1 class="page-header__title">
        📦 Prepara Ordine
        <span class="chip-prep">
          <i class="bx bx-package"></i>
          Operatore Magazzino
        </span>
      </h1>
      <p class="page-header__subtitle">
        @if (visibleOrders.length > 0) {
          <strong>{{ visibleOrders.length }}</strong>
          {{ visibleOrders.length === 1 ? 'ordine da preparare' : 'ordini da preparare' }}
          @if (filterTerm) { · ricerca <strong>"{{ filterTerm }}"</strong> }
        } @else if (loading) {
          Caricamento ordini…
        } @else {
          Nessun ordine da preparare al momento
        }
      </p>
    </div>
  </header>

  <!-- ============ KPI BANNER 3+4 ============ -->
  <section class="kpi-grid">
    <!-- ROW 1: Totale + Completi + Parziali (split per or_partial) -->
    <div class="kpi-row kpi-row--top3">
      <article class="kpi-card kpi-card--total">
        <header class="kpi-card__head">
          <span class="kpi-card__icon" aria-hidden="true">📊</span>
          <h3 class="kpi-card__label">Totale Imponibile</h3>
        </header>
        <p class="kpi-card__value">{{ netValue | currency:'EUR':'symbol':'1.2-2' }}</p>
        <p class="kpi-card__sub">
          {{ visibleOrders.length }} {{ visibleOrders.length === 1 ? 'ordine' : 'ordini' }}
        </p>
        <div class="kpi-card__bar">
          <div class="kpi-card__bar-fill" [style.width.%]="100"></div>
        </div>
      </article>

      <article class="kpi-card kpi-card--complete">
        <header class="kpi-card__head">
          <span class="kpi-card__icon" aria-hidden="true">✅</span>
          <h3 class="kpi-card__label">Completi</h3>
        </header>
        <p class="kpi-card__value">{{ etValueTotal | currency:'EUR':'symbol':'1.2-2' }}</p>
        <p class="kpi-card__sub">
          {{ completeOrdersCount }} {{ completeOrdersCount === 1 ? 'ordine' : 'ordini' }}
        </p>
        <div class="kpi-card__bar">
          <div class="kpi-card__bar-fill" [style.width.%]="completeOrdersPercentageCount"></div>
        </div>
      </article>

      <article class="kpi-card kpi-card--partial">
        <header class="kpi-card__head">
          <span class="kpi-card__icon" aria-hidden="true">📦</span>
          <h3 class="kpi-card__label">Parziali</h3>
        </header>
        <p class="kpi-card__value">{{ etValuePartial | currency:'EUR':'symbol':'1.2-2' }}</p>
        <p class="kpi-card__sub">
          {{ partialOrdersCount }} {{ partialOrdersCount === 1 ? 'ordine' : 'ordini' }}
        </p>
        <div class="kpi-card__bar">
          <div class="kpi-card__bar-fill" [style.width.%]="partialOrdersPercentageCount"></div>
        </div>
      </article>
    </div>

    <!-- ROW 2: Assegnati + In Lavorazione + Sospesi + Bloccati (split per status) -->
    <div class="kpi-row kpi-row--bottom4">
      <article class="kpi-card kpi-card--assigned">
        <header class="kpi-card__head">
          <span class="kpi-card__icon" aria-hidden="true">👤</span>
          <h3 class="kpi-card__label">Assegnati</h3>
        </header>
        <p class="kpi-card__value">{{ etValueAssigned | currency:'EUR':'symbol':'1.2-2' }}</p>
        <p class="kpi-card__sub">
          {{ assignedOrdersCount }} {{ assignedOrdersCount === 1 ? 'ordine' : 'ordini' }}
        </p>
        <div class="kpi-card__bar">
          <div class="kpi-card__bar-fill" [style.width.%]="assignedOrdersPercentageCount"></div>
        </div>
      </article>

      <article class="kpi-card kpi-card--working">
        <header class="kpi-card__head">
          <span class="kpi-card__icon" aria-hidden="true">⚙️</span>
          <h3 class="kpi-card__label">In Lavorazione</h3>
        </header>
        <p class="kpi-card__value">{{ etValueWorking | currency:'EUR':'symbol':'1.2-2' }}</p>
        <p class="kpi-card__sub">
          {{ workingOrdersCount }} {{ workingOrdersCount === 1 ? 'ordine' : 'ordini' }}
        </p>
        <div class="kpi-card__bar">
          <div class="kpi-card__bar-fill" [style.width.%]="workingOrdersPercentageCount"></div>
        </div>
      </article>

      <article class="kpi-card kpi-card--suspended">
        <header class="kpi-card__head">
          <span class="kpi-card__icon" aria-hidden="true">⏸️</span>
          <h3 class="kpi-card__label">Sospesi</h3>
        </header>
        <p class="kpi-card__value">{{ etValueSuspended | currency:'EUR':'symbol':'1.2-2' }}</p>
        <p class="kpi-card__sub">
          {{ suspendedOrdersCount }} {{ suspendedOrdersCount === 1 ? 'ordine' : 'ordini' }}
        </p>
        <div class="kpi-card__bar">
          <div class="kpi-card__bar-fill" [style.width.%]="suspendedOrdersPercentageCount"></div>
        </div>
      </article>

      <article class="kpi-card kpi-card--blocked">
        <header class="kpi-card__head">
          <span class="kpi-card__icon" aria-hidden="true">🛑</span>
          <h3 class="kpi-card__label">Bloccati</h3>
        </header>
        <p class="kpi-card__value">{{ etValueBlocked | currency:'EUR':'symbol':'1.2-2' }}</p>
        <p class="kpi-card__sub">
          {{ blockedOrdersCount }} {{ blockedOrdersCount === 1 ? 'ordine' : 'ordini' }}
        </p>
        <div class="kpi-card__bar">
          <div class="kpi-card__bar-fill" [style.width.%]="blockedOrdersPercentageCount"></div>
        </div>
      </article>
    </div>
  </section>

  <!-- ============ FILTER BAR ============ -->
  <section class="filter-bar" role="search" aria-label="Filtra ordini">
    <div class="filter-bar__group filter-bar__group--search">
      <div class="search-input-wrap">
        <span class="search-icon" aria-hidden="true">🔍</span>
        <input
          type="search"
          class="search-input"
          [(ngModel)]="filterTerm"
          (ngModelChange)="onSearchInput()"
          (keyup.enter)="searchOrders()"
          placeholder="Cerca ordine, cliente, riferimento..."
          autofocus
        />
        @if (filterTerm) {
          <button
            type="button"
            class="search-clear"
            title="Pulisci ricerca"
            (click)="clearSearch()"
          >✕</button>
        }
      </div>
    </div>

    <div class="filter-bar__group filter-bar__group--dates">
      <label class="date-field">
        <span class="date-label">Dal</span>
        <input type="date" class="date-input" [(ngModel)]="startDateStr" />
      </label>
      <label class="date-field">
        <span class="date-label">Al</span>
        <input type="date" class="date-input" [(ngModel)]="endDateStr" />
      </label>
    </div>

    <button
      type="button"
      class="btn btn--primary"
      (click)="searchOrders()"
      [disabled]="loading"
    >🔍 Cerca</button>
  </section>

  <!-- ============ TABLE CARD ============ -->
  <section class="prep-table-card" aria-label="Elenco ordini">

    @if (loading) {
      <div class="table-skeleton" aria-busy="true">
        @for (i of [1, 2, 3, 4, 5, 6, 7, 8]; track i) {
          <div class="table-skeleton__row">
            <div class="table-skeleton__line table-skeleton__line--lg"></div>
            <div class="table-skeleton__line table-skeleton__line--md"></div>
            <div class="table-skeleton__line table-skeleton__line--sm"></div>
          </div>
        }
      </div>
    } @else {
      @if (visibleOrders.length === 0) {
        <div class="prep-empty">
          <div class="prep-empty__icon" aria-hidden="true">
            @if (filterTerm) { 🔎 } @else { 📭 }
          </div>
          <p class="prep-empty__msg">
            @if (filterTerm) {
              Nessun ordine corrisponde a <strong>"{{ filterTerm }}"</strong>.
            } @else {
              Nessun ordine da preparare al momento.
            }
          </p>
        </div>
      } @else {
        <div class="prep-table-scroll">
          <table class="prep-table" role="table">
            <thead>
              <tr>
                <th class="col-order is-sortable" (click)="sortBy('or_order_number')">
                  N° ordine
                  @if (sortColumn === 'or_order_number') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                <th class="col-customer is-sortable" (click)="sortBy('or_customer')">
                  Cliente
                  @if (sortColumn === 'or_customer') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                <th class="col-date is-sortable" (click)="sortBy('or_net_value')">
                  Importo
                  @if (sortColumn === 'or_net_value') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                <th class="col-date is-sortable" (click)="sortBy('tab_order_priority_desc')">
                  Priority
                  @if (sortColumn === 'tab_order_priority_desc') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                 <th class="col-date is-sortable" (click)="sortBy('ac_first_name')">
                  Operatore
                  @if (sortColumn === 'ac_first_name') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                 <th class="col-date is-sortable" (click)="sortBy('tab_order_status_perc')">
                  Avanzamento
                  @if (sortColumn === 'tab_order_status_perc') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                <th class="col-date is-sortable" (click)="sortBy('or_order_date')">
                  Data ordine
                  @if (sortColumn === 'or_order_date') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                 <th class="col-date is-sortable" (click)="sortBy('or_assigned_date')">
                  Assegnazione
                  @if (sortColumn === 'or_assigned_date') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                <th class="col-date is-sortable" (click)="sortBy('expected_shipping_date')">
                  Data evasione
                  @if (sortColumn === 'expected_shipping_date') {
                    <span class="sort-indicator">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                  }
                </th>
                <th class="col-actions">Azioni</th>
              </tr>
            </thead>
            <tbody>
              @for (
                order of visibleOrders;
                track order.order_id + '-' + ($index)
              ) {
                <tr
                  class="prep-row"
                  [ngClass]="rowClassFor(order)"
                  (click)="gotoDetails(order.order_id)"
                  [title]="'Apri dettagli ordine ' + (order.or_order_number || '')"
                >
                  <td class="col-order">
                    @if (order.or_note?.trim()) {
                      <span class="cell-note-icon" title="Note presenti su questo ordine" aria-label="Note presenti">📌</span>
                    }
                    <span
                      class="cell-order-num"
                      (mouseenter)="onHoverStart(order.order_id)"
                      (mouseleave)="onHoverEnd()"
                    >
                      {{ order.or_order_number || '—' }}
                    </span>
                  </td>
                  <td class="col-customer">
                    <span class="cell-customer">{{ order.or_customer || '—' }}</span>
                  </td>
                  <td class="col-amount">
                    <span class="cell-amount">
                      {{ order.or_net_value | currency:'EUR':'symbol':'1.2-2' }}
                    </span>
                  </td>
                  <td class="col-priority">
                    <span class="priority-chip">
                      {{ order.tab_order_priority_desc || '—' }}
                    </span>
                  </td>
                  <td class="col-operator" (click)="$event.stopPropagation()">
                    <span class="cell-operator-name">
                      {{ order.ac_first_name }}
                      {{ order.ac_last_name ? (order.ac_last_name.substring(0, 1) + '.') : '' }}
                    </span>
                    <button
                      type="button"
                      class="icon-btn icon-btn--neutral"
                      [title]="isBlocked(order)
                        ? 'Cambia operatore'
                        : 'Blocca prima l’ordine per cambiare operatore'"
                      [disabled]="!isBlocked(order)"
                      (click)="openChangeOperator(order)"
                    >🔁</button>
                  </td>
                  <td class="col-progress">
                    <div class="progress-wrap">
                      <div
                        class="progress-fill"
                        [style.width.%]="+(order.tab_order_status_perc || 0)"
                      ></div>
                      <span class="progress-label">
                        {{ +(order.tab_order_status_perc || 0) | number:'1.0-0' }}%
                      </span>
                    </div>
                  </td>
                  <td class="col-date">
                    <span class="cell-date">{{ order.or_order_date ? (order.or_order_date | date:'dd/MM/yyyy') : '—' }}</span>
                  </td>
                  <td class="col-date">
                    <span class="cell-date">{{ order.or_assigned_date ? (order.or_assigned_date | date:'dd/MM/yyyy') : '—' }}</span>
                  </td>
                  <td class="col-date">
                    <span class="cell-date">{{ order.expected_shipping_date ? (order.expected_shipping_date | date:'dd/MM/yyyy') : '—' }}</span>
                  </td>
                  <td class="col-actions" (click)="$event.stopPropagation()">
                    <div class="row-actions">
                      <!-- Check / Firma — sempre presente -->
                      <button
                        type="button"
                        class="icon-btn icon-btn--primary"
                        [title]="+(order.tab_order_status_perc || 0) >= 100 ? 'Firma ordine' : 'Controlla / Prepara'"
                        aria-label="Apri dettagli ordine"
                        (click)="gotoDetails(order.order_id)"
                      >
                        @if (+(order.tab_order_status_perc || 0) >= 100) { ✍️ } @else { ✏️ }
                      </button>

                      <!-- Cancel — solo se non c'è DDT -->
                      @if (!order.or_url_ddt || order.or_url_ddt.indexOf('.pdf') === -1) {
                        <button
                          type="button"
                          class="icon-btn icon-btn--danger"
                          title="Annulla ordine"
                          aria-label="Annulla ordine"
                          (click)="confirmCancel(order)"
                        >🗑️</button>
                      }

                      <!-- Block / Unblock toggle -->
                      @if (isBlocked(order)) {
                        <button
                          type="button"
                          class="icon-btn icon-btn--blocked"
                          title="Ordine bloccato — clicca per sbloccare"
                          aria-label="Sblocca ordine"
                          [disabled]="isStatusToggling(order)"
                          (click)="unblock(order)"
                        >🛑</button>
                      } @else {
                        <button
                          type="button"
                          class="icon-btn icon-btn--unblocked"
                          title="Ordine attivo — clicca per bloccare"
                          aria-label="Blocca ordine"
                          [disabled]="isStatusToggling(order)"
                          (click)="block(order)"
                        >🔓</button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </section>
</div>

<!-- Sub-modale conferma cancellazione -->
@if (openModal.isConfirmCancel) {
  <app-confirm-cancel
    [openConfirmCancel]="openModal.isConfirmCancel"
    [orderToGet]="orderToSend"
    (canceledSucces)="loadOrders()"
  ></app-confirm-cancel>
}
